import React from "react";

const ProductListComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default ProductListComponent;
